import Stack from "@mui/material/Stack";
import { Theme } from "../../data/style/Theme";
import { CenteredRow, MainText, SmallTitle } from "../../data/style/Style";

const StatsBanner = ({ place, text, icon, color }) => {
  return (
    <CenteredRow
      flex={1}
      gap={1}
      p={0.5}
      sx={{
        background: Theme.palette.card,
        border: 1,
        borderColor: Theme.palette.border,
        borderRadius: 4,
      }}
    >
      <MainText>{icon}</MainText>
      <Stack gap={1}>
        <SmallTitle fontSize={"0.6rem"}>{text}</SmallTitle>
        <MainText
          fontWeight={700}
          fontSize={"0.8rem"}
          sx={{ color: color + " !important" }}
        >
          # {place}
        </MainText>
      </Stack>
    </CenteredRow>
  );
};

export default StatsBanner;
